import {gql} from 'apollo-angular';
import {Injectable} from '@angular/core';
import {ApiService} from 'app/shared/modules/api/services/api.service';

const mutation = gql`
    mutation finishDemo {
        finishDemo
    }
`;

@Injectable()
export class DisableDemoService {
    constructor(private api: ApiService) {}

    finish() {
        return this.api.mutate({mutation, skipBeforeMutationValidation: true});
    }
}
